webpackJsonp([19368514652012],{

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CapabilityServerlessPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Head = __webpack_require__(17);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _contact = __webpack_require__(18);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CapabilityServerlessPage = function CapabilityServerlessPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Serverless | ' + data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'hero is-relative is-theme-secondary hero-waves' },
	        _react2.default.createElement(_Head2.default, null),
	        _react2.default.createElement(
	          'div',
	          { id: 'main-hero', className: 'hero-body ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns is-vcentered is-tablet-portrait' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-5 header-caption has-text-left' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'landing-title' },
	                  'Serverless Solutions'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'subtitle is-5 light-text' },
	                  'We built a scalable serverless solution that allows for quick and responsive access to your content across the world, coupled with automatic scaling as your needs increase.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'pt-10 pb-10' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#contact-form', className: 'button button-cta btn-align btn-outlined is-bold light-btn rounded z-index-2' },
	                    'Let\'s build together'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-9 is-offset-1' },
	                _react2.default.createElement(
	                  'figure',
	                  { className: 'image is-16by9' },
	                  _react2.default.createElement('img', { src: '/files/images/illustrations/UI/serverless-landing.png', alt: '' })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'features', className: 'section is-medium' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-title-wrapper has-text-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bg-number' },
	              '1'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'section-title-landing' },
	              'Why you should move to Serverless?'
	            ),
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Though traditional deployment strategies like VM\'s and containers are powerful, each of them have their own limitations...'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns is-vcentered has-text-centered' },
	              _react2.default.createElement('div', { className: 'column is-hidden-mobile' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing secondary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'far fa-clock' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'More time to market'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'The path of delivering applications to market is a long one. Along with product planning and development, you also have to think about the infrastructure, setup and capacity.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing secondary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'fas fa-lock' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Fixed costs'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'Traditional servers force you to have a fixed cost. Whether you have or don\u2019t have usage.',
	                    ' ',
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'invisible-white' },
	                      ' Whether you have or don\u2019t have usage. Whether you have or don\u2019t have usage.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing primary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'fas fa-money-bill-wave-alt' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Less flexibility'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'Many applications are tightly coupled, which is a big problem. Even a slight change in your product course can cause painful refactoring or rewrites. ',
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'invisible-white' },
	                      ' which is a big problem. '
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'column is-hidden-mobile' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'columns is-vcentered has-text-centered' },
	              _react2.default.createElement('div', { className: 'column is-hidden-mobile' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing secondary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'fas fa-file-invoice-dollar' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Paying for the unused'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'Renting servers means you have to pay for the those times also when you ae not using it, making it highly expensive for you.',
	                    ' ',
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'invisible-white' },
	                      ' spent time and effort. '
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing secondary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'fab fa-creative-commons-nc' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'More waste'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'When developing multiple products, certain features are repeatedly developed over and over again. Increasing the waste in spent time and effort.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'square-icon-box is-landing primary' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'icon-box-wrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'icon-box' },
	                      _react2.default.createElement('i', { className: 'fas fa-thumbs-down' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'No service stability'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-text is-tablet-padded' },
	                    'A single service crashing can cause the whole monolith to crash increasing your time and cost.',
	                    ' ',
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'invisible-white' },
	                      ' the whole monolith to crash increasing your time and cost. '
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', { className: 'column is-hidden-mobile' })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { id: 'services', className: 'section section-feature-grey is-medium' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section-title-wrapper has-text-centered' },
	            _react2.default.createElement(
	              'div',
	              { className: 'bg-number' },
	              '1'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'section-title-landing' },
	              _react2.default.createElement(
	                'i',
	                null,
	                ' Serverless '
	              ),
	              ' relieve these limitations by allowing you to build & deploy auto-scaling, pay-per-execution, event-driven functions.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns is-vcentered is-multiline has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wavy-icon-box' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'is-icon-reveal' },
	                    _react2.default.createElement('i', { className: 'fas fa-screwdriver' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Zero administration'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'box-content is-tablet-padded' },
	                    'Deploy code without provisioning anything beforehand, or managing anything afterward. No more bothering the Ops department.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wavy-icon-box' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'is-icon-reveal' },
	                    _react2.default.createElement('i', { className: 'fas fa-magic' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Auto-scaling'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'box-content is-tablet-padded' },
	                    'Let your service providers manage the scaling challenges. No need to fire alerts or write scripts to scale up and down.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wavy-icon-box' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'is-icon-reveal' },
	                    _react2.default.createElement('i', { className: 'fas fa-hand-holding-usd' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Pay-per-use'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'box-content is-tablet-padded' },
	                    'Function-as-a-service compute and managed services charged based on usage rather than pre-provisioned capacity.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'column is-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wavy-icon-box' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'is-icon-reveal' },
	                    _react2.default.createElement('i', { className: 'fas fa-shipping-fast' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'box-title' },
	                    'Increased velocity'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'box-content is-tablet-padded' },
	                    'Shorten the loop between having an idea and deploying to production. It\'s easier than ever to make your idea live.'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_contact2.default, null)
	  );
	};
	
	exports.default = CapabilityServerlessPage;
	var CapabilityServerlessPageQuery = exports.CapabilityServerlessPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-capabilities-serverless-jsx-f3164a4aa54338741b41.js